import axios from 'axios'

// 基础配置
const baseURL = 'https://control.zjwec.cn/api'

// 获取客户记录列表
export function getCustomerRecords(params) {
  return axios.get(`${baseURL}/customer-records/page`, { params })
    .then(response => response.data)
    .catch(error => {
      console.error('获取客户记录失败:', error)
      throw error
    })
}

// 根据ID获取客户记录
export function getCustomerRecordById(id) {
  return axios.get(`${baseURL}/customer-records/${id}`)
    .then(response => response.data)
    .catch(error => {
      console.error('获取客户记录详情失败:', error)
      throw error
    })
}

// 新增客户记录
export function addCustomerRecord(data) {
  return axios.post(`${baseURL}/customer-records/save`, data)
    .then(response => response.data)
    .catch(error => {
      console.error('新增客户记录失败:', error)
      throw error
    })
}

// 更新客户记录
export function updateCustomerRecord(data) {
  return axios.put(`${baseURL}/customer-records/update`, data)
    .then(response => response.data)
    .catch(error => {
      console.error('更新客户记录失败:', error)
      throw error
    })
}

// 删除客户记录
export function deleteCustomerRecord(id) {
  return axios.delete(`${baseURL}/customer-records/delete/${id}`)
    .then(response => response.data)
    .catch(error => {
      console.error('删除客户记录失败:', error)
      throw error
    })
}


// WEBPACK FOOTER //
// ./src/api/customer.js